import { Ear, Footprints } from "lucide-react";

/**
 * Display metadata only. Whether a practice is usable is the server's answer (GET /clinical/practices, shown by
 * clinical/PracticeSwitcher), never a flag in the browser.
 */
export const practices = {
  audiology: { name: "Audiology", Icon: Ear },
  podiatry: { name: "Podiatry", Icon: Footprints },
} as const;
export type PracticeId = keyof typeof practices;
export type FieldView =
  "day" | "today" | "manifest" | "schedule" | "devices" | "inventory" | "followups" | "atd-all" | "twl";
export const isFieldView = (value: string | null): value is FieldView =>
  value !== null &&
  [
    "day",
    "today",
    "manifest",
    "schedule",
    "devices",
    "inventory",
    "followups",
    "atd-all",
    "twl",
  ].includes(value);

/**
 * The Podiatry workspace's views (2026-11-03). They are addressable like the field workspace's, so Back, Forward, a
 * refresh and a shared link all name the same view. The facility stays in the path and the view in the query, in a
 * parameter of its own (`pview`) because `view` is the field workspace's: the shell corrects any `view` it does not
 * know to Today, and a Podiatry word must not be corrected away. Residents is the default and carries no query, so
 * `/provider/:facilityId` is the Podiatry home; anything else (including an unknown word) lands there.
 */
export type PodiatryView = "buildings" | "residents";
export const PODIATRY_VIEW_PARAM = "pview";
export const isPodiatryView = (value: string | null): value is PodiatryView =>
  value === "buildings" || value === "residents";
export const podiatryPath = (facilityId: string, view: PodiatryView): string => {
  const base = facilityId ? `/provider/${facilityId}` : "/provider";
  return view === "residents" && facilityId ? base : `${base}?${PODIATRY_VIEW_PARAM}=${view}`;
};
